import { LazyLoad } from 'app/utils';

export const DonationListPage = LazyLoad(
  () => import('./index'),
  (module) => module.DonationListPage,
);
